<template>
  <transition enter-active-class="transition-ease-in-out"
              leave-active-class="transition-ease-in-out">
    <div class="pa-6" style="background: rgba(35,53,71, .56)">
      <p class="text-h4 text-center white--text" >{{ tip.advice | quote}}</p>
    </div>
  </transition>
</template>

<script>
import axios from "axios"
export default {
  name: "TipsComponent",
  data() {
    return {
      tip: {
        advice: null
      },
      interval: null
    }
  },
  mounted() {
    this.getTip();
    this.fetchEntriesDebounced();
  },
  methods: {
    getTip() {
      axios.get('https://api.adviceslip.com/advice')
          .then(response => {
            this.tip = response.data.slip;
          })
    },
    fetchEntriesDebounced() {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.getTip()
      }, 1000 * 60)
    }
  }
}
</script>

<style scoped>

</style>
